import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/authenticate',
    name: 'Authenticate',
    component: () => import(/* webpackChunkName: "authenticate" */ '../views/Authenticate.vue')
  },
  {
    path: '/account',
    name: 'Account', 
    component: () => import(/* webpackChunkName: "account" */ '../components/AccountManagement.vue')
  },

  {
    path: '/books',
    name: 'BookList',
    component: () => import(/* webpackChunkName: "booklist" */ '../views/BookList.vue')
  },

  {
    path: '/',
    name: 'Dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue')
  },

  // NOTFOUND CATCHALL ROUTE
  {
    path: '*',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "notFound" */ '../views/404.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
